import { time, events, EntityEnvironment } from "@dinahmoe/dmafjs-core";
import { webAudioEngine } from "./webaudio_engine";

class WebAudioContext extends EntityEnvironment {
  context = this.#createWebAudioContext();

  #createWebAudioContext() {
    if (typeof window === "undefined") {
      return null;
    }

    const AudioContext = window.AudioContext || window.webkitAudioContext;

    if (!AudioContext) {
      return null;
    }

    const ctx = new AudioContext();

    //ctx = fillMethods(AudioContext);
    ctx.kickstart = this.initializeContext.bind(this);

    window.addEventListener("touchend", ctx.kickstart, true);
    window.addEventListener("mouseup", ctx.kickstart, true);
    window.addEventListener("keyup", ctx.kickstart, true);
    window.addEventListener("CookiebotOnAccept", ctx.kickstart);

    return ctx;
  }

  async initializeContext() {
    if (this.context.state === "suspended") {
      await this.context
        .resume()
        .then(() => {
          this.#activateContext.call(this);
        })
        .catch((err) => console.log(err));
    } else {
      this.#activateContext.call(this);
    }
  }

  #activateContext() {
    events.addEventToQueue("webaudio:unlocked", time.current, {});
    webAudioEngine.setOffset(this.context);

    console.log("CONTEXT UNLOCKED", this.context.sampleRate);

    window.removeEventListener("touchend", this.context.kickstart, true);
    window.removeEventListener("mouseup", this.context.kickstart, true);
    window.removeEventListener("keyup", this.context.kickstart, true);
    window.removeEventListener("CookiebotOnAccept", this.context.kickstart);
  }
}

const webAudioContext = new WebAudioContext("WebAudioContext");
export { webAudioContext, WebAudioContext };
